import QuestionFiles from './QuestionFiles.component';

export default QuestionFiles;